<template>
  <!-- 行业弹窗组件 -->
  <div
    class="form-container"
    :style="{ backgroundImage: 'url(' + $serverImgUrl + 'popup3.png' + ')' }"
  >
    <img
      :src="$serverImgUrl + 'popup4.png'"
      alt="企业建筑"
      class="building-image"
    />
    <!-- 顶部标题和图片 -->
    <div class="header-section">
      <h1 class="form-title">企业核心业务，邀您来揭晓~</h1>
      <button class="close-button" @click="handleClose">×</button>
    </div>

    <!-- 表单内容 -->
    <div class="form-content">
      <el-form
        ref="industryForm"
        :model="formData"
        :rules="rules"
        label-position="top"
      >
        <!-- 企业名称输入 -->
        <el-form-item label="您的企业名称" prop="companyName" class="form-item">
          <el-input
            v-model="formData.companyName"
            placeholder="请输入"
            class="form-input"
            clearable
          ></el-input>
        </el-form-item>

        <!-- 企业业务输入 -->
        <el-form-item
          label="您的企业是做什么的?"
          prop="content"
          class="form-item"
        >
          <el-input
            v-model="formData.content"
            placeholder="请输入"
            class="form-input"
            clearable
            :suffix-icon="analyseLoading ? 'el-icon-loading' : ''"
          ></el-input>
        </el-form-item>

        <!-- 推荐选项 -->
        <el-form-item class="form-item">
          <div class="recommendation-section">
            <el-row>
              <!-- :span="4" -->
              <el-col><div>推荐：</div></el-col>
              <el-col :span="20"
                ><div class="tag-container">
                  <div
                    v-for="(item, index) in IndustryListData"
                    :key="index"
                    class="recommendation-tag"
                    @click="selectTag(index)"
                    :class="{ active: selectedTagIndex === index }"
                  >
                    {{ item.industryName }}
                  </div>
                </div></el-col
              >
            </el-row>
          </div>
        </el-form-item>

        <!-- 提交按钮 -->
        <div style="text-align: center">
          <el-button
            style="width: 120px"
            class="custom-btn none-radius"
            type="primary"
            @click="handleSubmit"
            >提交</el-button
          >
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "MaskOverlayIndustry",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 弹窗是否显示
      showOverlay: this.show,
      // 表单数据
      formData: {
        companyName: "",
        content: "",
      },
      // 选中的行业分类索引
      selectedTagIndex: -1,
      // AI分析加载状态
      analyseLoading: false,
      // 防抖定时器
      analyseTimer: null,
      // 标记是否正在自动选择，防止回填时再次触发watch
      isAutoSelecting: false,
      // 行业分类列表
      IndustryListData: [],
      // 表单验证规则
      rules: {
        companyName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "企业名称长度不能超过50个字符",
            trigger: "blur",
          },
        ],
        content: [
          { required: true, message: "请输入您的企业是做什么的", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    show(newVal) {
      this.showOverlay = newVal;
    },
    // 监听企业业务输入，输入完成后自动调用AI分析接口
    "formData.content": {
      handler: "debouncedAnalyseIndustry",
    },
  },
  created() {
    // 初始化时获取行业分类列表
    this.getIndustryList();
  },
  methods: {
    // 防抖调用AI行业分析（500ms内无新输入则触发）
    debouncedAnalyseIndustry(newVal) {
      // 如果是程序自动回填，跳过，避免循环触发
      if (this.isAutoSelecting) {
        this.isAutoSelecting = false;
        return;
      }
      if (this.analyseTimer) {
        clearTimeout(this.analyseTimer);
      }
      if (!newVal || !newVal.trim()) {
        return;
      }
      this.analyseTimer = setTimeout(() => {
        this.analyseIndustry(newVal.trim());
      }, 500);
    },
    // 调用AI接口分析企业行业，自动匹配IndustryListData
    async analyseIndustry(message) {
      if (this.analyseLoading) return;
      this.analyseLoading = true;
      try {
        const res = await this.$api.product.aiAnalyseCompanyIndustryAPI({
          message,
        });
        if (res && res.data) {
          const { industryName, industryId } = res.data;
          if (industryName) {
            // 在IndustryListData中查找匹配的行业
            const matchedIndex = this.IndustryListData.findIndex(
              (item) => item.industryName === industryName,
            );
            if (matchedIndex !== -1) {
              this.isAutoSelecting = true;
              this.selectedTagIndex = matchedIndex;
              this.formData.content =
                this.IndustryListData[matchedIndex].industryName;
            }
          }
        }
      } catch (error) {
        console.error("AI行业分析失败:", error);
      } finally {
        this.analyseLoading = false;
      }
    },
    // 获取行业分类列表
    async getIndustryList() {
      try {
        // 核心调用：模块名 + action名
        const industryList = await this.$store.dispatch(
          "dataCache/fetchIndustryListData",
        );
        this.IndustryListData = industryList || [];
        // 拿到数据后你可以直接用
        console.log("行业分类数据：", industryList);
      } catch (err) {
        this.$message.error(err.message || "获取行业分类失败");
      }
    },
    handleClose() {
      // 可以通过事件或回调通知父组件关闭遮罩层
      this.$emit("close", "industry");
    },
    selectTag(index) {
      this.selectedTagIndex = index;
      this.formData.content = this.IndustryListData[index].industryName;
    },
    async handleSubmit() {
      // 表单验证
      const valid = await this.$refs.industryForm.validate().catch(() => false);
      if (!valid) return;
      try {
        // 准备提交数据
        const submitData = {
          companyName: this.formData.companyName.trim(),
          content: this.formData.content.trim(),
          industryId:
            this.selectedTagIndex !== -1
              ? this.IndustryListData[this.selectedTagIndex].industryId
              : "",
        };
        console.log("提交的企业分类信息:", submitData);
        // 调用 wx/type 接口
        const res = await this.$api.product.submitCompanyTypeAPI(submitData);

        if (res && res.code === 200) {
          res.data.tags = res.data.sceneIds.split(",");
          console.log("wx/type 接口返回:", res.data);
          // 提交后清空表单
          this.$refs.industryForm.resetFields();
          this.selectedTagIndex = -1;
          // 通知父组件提交成功，传递接口返回数据用于回显
          this.$emit("submit", res.data || res);
          this.handleClose();
        } else {
          this.$message.error((res && res.msg) || "提交失败");
        }
      } catch (error) {
        console.error("提交异常:", error);
        this.$message.error(error.message || "提交失败");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form-container {
  // background-image: url("https://lingxin1314.oss-cn-beijing.aliyuncs.com/weixiaozhu/popup3.png");
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 37px;
  // height: 500px;
  // width: 580px;
  max-width: 600px;
  box-sizing: border-box;
  position: relative;
}

.header-section {
  padding: 25px 30px 0;
  position: relative;
  display: flex;
}

.form-title {
  font-family: Source Han Sans;
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #0e3c75;
  font-weight: 600;
  margin: 0;
  flex: 1;
}

.building-image {
  position: absolute;
  right: 30px;
  top: -35px;
  max-height: 154px;
  // transform: translateY(-50%);
}

.close-button {
  position: absolute;
  right: 15px;
  top: 15px;
  background: none;
  border: none;
  color: #0e3c75;
  font-size: 30px;
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  z-index: 10;
}

.close-button:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.form-content {
  border-radius: 20px;
  opacity: 1;
  background: rgba(255, 255, 255, 0.3);
  box-sizing: border-box;
  border-image: linear-gradient(216deg, #e5efff 26%, #ffffff 100%) 1;
  backdrop-filter: blur(15px);
  margin: 10px 20px 20px;
  padding: 40px 35px 30px 35px;
  box-sizing: border-box;
  .el-form {
    .el-form-item {
      .el-form-item__content {
        border: 3px solid red;
      }
    }
  }
}

.form-label {
  display: block;
  color: #333;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 8px;
}

.form-input {
  width: 100%;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.recommendation-section {
  margin-bottom: 30px;
  display: flex;
}

.recommendation-label {
  flex: 2;
  display: block;
  color: #666;
  font-size: 14px;
  margin-top: 6px;
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: -10px;
}

.recommendation-tag {
  padding: 0 15px;
  border-radius: 21px;
  opacity: 1;
  background: #d7e8ff;
  font-size: 13px;
  color: #26426c;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
  line-height: 30px;
}

.recommendation-tag:hover {
  background-color: var(--primary-color);
  color: #fff;
}

.recommendation-tag.active {
  background-color: var(--primary-color);
  color: white;
}

.submit-button {
  width: 100%;
  padding: 14px;
  background-color: #348cf8;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.submit-button:hover {
  background-color: #2a76e6;
}

/* 响应式设计 */
@media (max-width: 576px) {
  .form-container {
    width: 95%;
    margin: 20px;
  }

  .header-section {
    padding: 20px 25px 15px;
  }

  .form-title {
    font-size: 16px;
  }

  .building-image {
    width: 60px;
    right: 20px;
  }

  .form-content {
    padding: 20px;
  }
}
</style>
